export { Text } from './text';
export { Heading } from './heading';
export { Headline } from './headline';
export { Prose } from './prose';
export { SideBySide } from './side-by-side';
export { TextWithIcon } from './text-with-icon';
//# sourceMappingURL=index.js.map